<p-dialog *ngIf="policyDocument"
          header="{{ (policyDocument.id ? 'WS_DIRECTORY.POLICY_DOCUMENTS.POLICY_DOCUMENTS_DIALOG.MODIFY_HEADER' : 'WS_DIRECTORY.POLICY_DOCUMENTS.POLICY_DOCUMENTS_DIALOG.CREATE_HEADER') | translate }}"
          [(visible)]="display"

          [modal]="true"
          [draggable]="false"
          class="admin-dialog">
  <form [formGroup]="policyDocumentForm">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g">
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.POLICY_DOCUMENTS.POLICY_DOCUMENTS_DIALOG.POLICY_DOCUMENT_NAME' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="policyDocumentForm.get('documentName')">
              <input pInputText formControlName="documentName">
            </gs-extended-input>
          </div>
          <div class="ui-g-12">
            <div class="ui-g m-b-0">
              <div class="ui-g-5">
                <label>{{ 'WS_DIRECTORY.POLICY_DOCUMENTS.POLICY_DOCUMENTS_DIALOG.ORDER' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <gs-extended-input [control]="policyDocumentForm.get('documentOrder')">
                  <p-dropdown dropdownIcon="fa fa-fw fa-chevron-down"
                              formControlName="documentOrder"
                              [options]="orderOptions"
                              scrollHeight="150px">
                  </p-dropdown>
                </gs-extended-input>
              </div>
            </div>
          </div>
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.POLICY_DOCUMENTS.POLICY_DOCUMENTS_DIALOG.INACTIVE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <p-checkbox formControlName="inactive" binary="true" class="m-t-10"></p-checkbox>
          </div>
        </div>
        <div class="ui-g">
          <div class="ui-g-offset-5 ui-g-7">
            <button pButton class="ui-button-success m-r-15 inline-block"
                    type="submit"
                    (click)="save()"
                    [label]="'WS_DIRECTORY.SAVE' | translate"></button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>

